import type { IPublicClientApplication } from "@azure/msal-browser";
import { createContext } from "react";

export type MetaOSAppContextProps = {
  /**
   * The appearance of the prompt card. Supported types are 'web', 'in-app', and 'm365'. If not provided, 'in-app' will be used.
   */
  isMosApp: boolean;
  pca: IPublicClientApplication | undefined;
};

export const MetaOSAppContext = createContext<MetaOSAppContextProps>({
  isMosApp: false,
  pca: undefined,
});
